/* Copied from the live product page's video tiles. Two additions: it runs once per page
   (both sections may load it) and waits for the DOM so tiles in any section order are observed. */
(function () {
  if (window.__mfsVideoModalInit) return;
  window.__mfsVideoModalInit = true;
  function init() {

      const modal = document.getElementById('videoModal');
      const modalVideo = document.getElementById('modalVideo');
      const fullscreenBtn = document.getElementById('fullscreenBtn');
      const loadingSpinner = document.getElementById('loadingSpinner');

      // Intersection Observer for lazy playing
      const observer = new IntersectionObserver((entries) => {
        entries.forEach(entry => {
          const video = entry.target;
          const wrap = video.closest('.video-wrap');
          if (entry.isIntersecting) {
            // Try to autoplay. If the browser refuses (e.g. iOS Low Power Mode),
            // flag the tile so the play badge shows over the poster frame.
            video.play()
              .then(() => { if (wrap) wrap.classList.remove('autoplay-blocked'); })
              .catch(() => { if (wrap) wrap.classList.add('autoplay-blocked'); });
          } else {
            video.pause();
          }
        });
      }, { threshold: 0.5 });

      // Observe all videos
      document.querySelectorAll('.video-wrap video').forEach(video => {
        observer.observe(video);
      });

      window.openVideoModal = function(videoWrap) {
        const sourceVideo = videoWrap.querySelector('video');

        // Show loading spinner
        loadingSpinner.classList.add('visible');

        modalVideo.src = sourceVideo.dataset.full || sourceVideo.src;
        modalVideo.currentTime = 0;
        modalVideo.muted = false;
        modalVideo.volume = 1.0;
        modal.classList.add('active');
        document.body.style.overflow = 'hidden';

        // Hide spinner when video can play
        const hideSpinner = () => {
          loadingSpinner.classList.remove('visible');
          modalVideo.removeEventListener('canplay', hideSpinner);
          modalVideo.removeEventListener('playing', hideSpinner);
        };

        modalVideo.addEventListener('canplay', hideSpinner);
        modalVideo.addEventListener('playing', hideSpinner);

        // Start playing
        modalVideo.play().catch(() => {
          // If play fails, still hide spinner
          loadingSpinner.classList.remove('visible');
        });
      };

      window.closeVideoModal = function() {
        modal.classList.remove('active');
        modalVideo.pause();
        modalVideo.src = '';
        loadingSpinner.classList.remove('visible');
        document.body.style.overflow = '';
      };

      window.closeModalOnBackdrop = function(event) {
        if (event.target === modal) closeVideoModal();
      };

      window.toggleFullscreen = function() {
        const modalContent = document.querySelector('.modal-content');

        if (!document.fullscreenElement) {
          if (modalContent.requestFullscreen) {
            modalContent.requestFullscreen();
          } else if (modalContent.webkitRequestFullscreen) {
            modalContent.webkitRequestFullscreen();
          } else if (modalContent.msRequestFullscreen) {
            modalContent.msRequestFullscreen();
          }
        } else {
          if (document.exitFullscreen) {
            document.exitFullscreen();
          } else if (document.webkitExitFullscreen) {
            document.webkitExitFullscreen();
          } else if (document.msExitFullscreen) {
            document.msExitFullscreen();
          }
        }
      };

      window.toggleMute = function() {
        const soundIcon = document.getElementById('soundIcon');
        const soundText = document.getElementById('soundText');

        if (modalVideo.muted) {
          modalVideo.muted = false;
          modalVideo.volume = 1.0;
          soundText.textContent = 'Звук увімкнено';
          soundIcon.innerHTML = '<path d="M3 9v6h4l5 5V4L7 9H3zm13.5 3c0-1.77-1.02-3.29-2.5-4.03v8.05c1.48-.73 2.5-2.25 2.5-4.02zM14 3.23v2.06c2.89.86 5 3.54 5 6.71s-2.11 5.85-5 6.71v2.06c4.01-.91 7-4.49 7-8.77s-2.99-7.86-7-8.77z"/>';
        } else {
          modalVideo.muted = true;
          soundText.textContent = 'Звук вимкнено';
          soundIcon.innerHTML = '<path d="M16.5 12c0-1.77-1.02-3.29-2.5-4.03v2.21l2.45 2.45c.03-.2.05-.41.05-.63zm2.5 0c0 .94-.2 1.82-.54 2.64l1.51 1.51C20.63 14.91 21 13.5 21 12c0-4.28-2.99-7.86-7-8.77v2.06c2.89.86 5 3.54 5 6.71zM4.27 3L3 4.27 7.73 9H3v6h4l5 5v-6.73l4.25 4.25c-.67.52-1.42.93-2.25 1.18v2.06c1.38-.31 2.63-.95 3.69-1.81L19.73 21 21 19.73l-9-9L4.27 3zM12 4L9.91 6.09 12 8.18V4z"/>';
        }
      };

      // Hide fullscreen button when in fullscreen mode
      function updateFullscreenButton() {
        if (document.fullscreenElement) {
          fullscreenBtn.classList.add('hidden');
        } else {
          fullscreenBtn.classList.remove('hidden');
        }
      }

      // Close modal with Escape key
      document.addEventListener('keydown', (e) => {
        if (e.key === 'Escape' && modal.classList.contains('active')) {
          closeVideoModal();
        }
      });

      // Update fullscreen button visibility
      document.addEventListener('fullscreenchange', updateFullscreenButton);
      document.addEventListener('webkitfullscreenchange', updateFullscreenButton);
    
  }
  if (document.readyState === 'loading') { document.addEventListener('DOMContentLoaded', init); } else { init(); }
})();
